<template>
  <div class="sscontainer-menu-footer a-propos"><h3>À propos</h3>
    <ul class="menu-footer">
      <li>
        <router-link
          :to="{name: 'About'}"
          target="_blank"
          title="Découvrir qui nous sommes">
          Qui sommes-nous ?
        </router-link>
      </li>
      <!--li><a href="#" title="Découvir COOLOC dans les medias">Dans les
        medias</a></li-->
      <li>
        <router-link
          :to="{name: 'CGU'}"
          target="_blank"
          title="Voir nos conditions générales d\'utilisation">
          CGU
        </router-link>
      </li>
      <li>
        <router-link
          :to="{name: 'Mentions'}"
          target="_blank"
          title="Voir nos informations légales">
          Mentions légales
        </router-link>
      </li>
      <!--li>
        <router-link
          :to="{name: 'LegalText'}"
          title="Découvrir notre politique de confidentialité">
          Données personnelles
        </router-link>
      </li-->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'footer-menus-about',
}
</script>
